import { Component, OnInit, ViewEncapsulation } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router';
import { MasterDataService } from 'app/shared/services/master-data.service';
import { ToastrService } from 'ngx-toastr';
import { InsuranceService } from '../../services/insurance.service';
import { RemittanceService } from 'app/modules/remittance/services/remittance.service';
import { CryptoUtils } from 'app/shared/utility/crypto.utils';
import { WsfxBankDetails } from 'app/shared/constant/wsfx-bank-details';
import { OrderService } from 'app/modules/order/services/order.service';
import { ConstantsKey } from 'app/shared/constant/constants-keys';

@Component({
  selector: 'insurance-payment',
  templateUrl: './insurance-payment.component.html',
  styleUrls: ['../../../../../@core/scss/angular/libs/select.component.scss',
    './insurance-payment.component.scss',
    '../../../../../@core/scss/base/pages/app-invoice.scss'],
  encapsulation: ViewEncapsulation.None
})
export class InsurancePaymentComponent implements OnInit {
  public plans: any;
  public showAddBankForm: boolean = false;
  public bankAccountList: any;
  public paymentMessage1 = "Please make the payment to the above mentioned account.";
  public paymentMessage2 = "Kindly note, funds transfer to be done from your registered bank account only.";
  public paymentMessage3 = "Once fund transfer made kindly update fund transfer details in payment section of order details page.";
  public bankAccountId: any;
  public paymentMode: any;
  public insuranceOrderId: any;
  public insuranceDetails: any;
  public showLoader: boolean = false;
  public cryptoUtils: CryptoUtils = new CryptoUtils();
  public responseJsonPaymentLink: any;
  public termsAndConditionUrl = "https://b2capptnc.s3.ap-south-1.amazonaws.com/TravelInsurance/Terms%26Conditions/TermsAndConditions.pdf";
  public tncUrl = "https://b2capptnc.s3.ap-south-1.amazonaws.com/TravelInsurance/Terms%26Conditions/TermsAndConditions.pdf";

  public accountName = WsfxBankDetails.ACCOUNT_NAME;
  public bankName = WsfxBankDetails.BANK_NAME;
  public accountNo = WsfxBankDetails.ACCOUNT_NUMBER;
  public bankIFSC = WsfxBankDetails.BANK_IFSC;
  public bankBranch = WsfxBankDetails.BANK_BRANCH;

  public NBPaymentHtml: string = "";
  public NBPaymentInProcees: boolean = false;

  constructor(
    public insuranceService: InsuranceService,
    private route: ActivatedRoute,
    public router: Router,
    public toast: ToastrService,
    public masterDataService: MasterDataService,
    public remittanceService: RemittanceService,
    public orderService: OrderService,
  ) {
    // this.insuranceDetails = JSON.parse(sessionStorage.getItem(ConstantsKey.INSURANCE_RESPONSE));
    // this.insuranceOrderId = this.insuranceDetails.cartOrderId;
    this.insuranceOrderId = this.route.snapshot.paramMap.get('ordercartdetailsId');
  }

  ngOnInit() {


    let isLoungeProcess = false;
    window.addEventListener('pageshow', (event) => {
      console.log("================================================================================= ESIM PAGE");
      let orderProcessStatus = localStorage.getItem(ConstantsKey.IS_INSURANCE_ORDER_DONE);
      if (orderProcessStatus && orderProcessStatus == "IN_PROCESS") {
        //window.location.reload(); //clean and reliable
        let orderData = localStorage.getItem(ConstantsKey.CURRENT_ORDER_TYPE);
        orderData = JSON.parse(orderData);
        let insuranceId = orderData["ORDER_ID"];
        localStorage.removeItem(ConstantsKey.IS_INSURANCE_ORDER_DONE);
        this.router.navigate(["/insurance-details/", insuranceId]);
        isLoungeProcess = true;
      }
    });


    this.getBankAccountList();
    this.getCartDetails();
  }

  getBankAccountList() {
    this.remittanceService.getBankAccountList().subscribe(resp => {
      this.bankAccountList = resp.body;
    }, error => {
    });
  }

  parentCallbackForAddBankAccountForm($event) {
    if ($event == 'ADD_BANK_ACCOUNT_ADDED') {
      this.showAddBankForm = false;
      this.getBankAccountList();
    }
  }

  getSelectedBankAccountID(id) {
    this.bankAccountId = id;
  }

  getCartDetails() {
    this.insuranceService.getTravelInsuranceCartDetails(this.insuranceOrderId).subscribe(resp => {
      this.showLoader = false;
      var responeJson = resp.body;
      // this.plans = JSON.parse(this.cryptoUtils.resDecrypt(responeJson));
      console.log("this.insuranceDetail >>>>>> ", responeJson);
      // console.log("responseJson>>> ", this.planDetails);
    }, error => {
      this.plans = JSON.parse(this.cryptoUtils.resDecrypt(error.error.text));
      console.log("this.insuranceDetail >>>>>> ", this.plans);

    });
  }

  proceedForPayment() {
    var responsePayment;
    this.showLoader = true;
    if (this.validateProceed()) {

      let orderType = { "ORDER_TYPE": "INSURANCE", "ORDER_ID": this.insuranceOrderId };
      localStorage.setItem(ConstantsKey.CURRENT_ORDER_TYPE, JSON.stringify(orderType));

        /* if ((this.paymentMode != null && this.paymentMode != '') && this.paymentMode == 'NB') {
          this.insuranceService.insuranceGetPaymentGatewayLink(this.insuranceOrderId, this.bankAccountId).subscribe(resp => {
            responsePayment = resp.body;
          }, error => {
            this.showLoader = false;
            responsePayment = JSON.parse(this.cryptoUtils.resDecrypt(error.error.text));
            localStorage.setItem(ConstantsKey.IS_INSURANCE_ORDER_DONE, "IN_PROCESS");            
            window.location.href = responsePayment.payment_link;
          });
        } else */ if ((this.paymentMode != null && this.paymentMode != '') && (this.paymentMode == 'UPI' || this.paymentMode == 'NB')) {
        this.getPayULink();

      } /* else {
          this.insuranceService.insuranceCartPlaceOrderNEFT(this.paymentMode, this.insuranceOrderId, this.plans?.totalPayableAmount).subscribe(resp => {
            this.showLoader = false;
            responsePayment = resp.body;
            this.router.navigate(['/payment-success', this.insuranceOrderId]);
          }, error => {
            this.showLoader = false;
            this.router.navigate(['/payment-success', this.insuranceOrderId]);
          });
        } */
    }

  }

  validateProceed() {

    if (!this.paymentMode) {
      this.toast.error("Please select payment mehtod");
      return false;
    }
    if (this.paymentMode == 'NB' && !this.bankAccountId) {
      this.toast.error("Please select bank account");
      return false;
    }
    return true;
  }
  keyPressNumbers(event) {
    var charCode = (event.which) ? event.which : event.keyCode;
    // Only Numbers 0-9
    if ((charCode < 48 || charCode > 57)) {
      event.preventDefault();
      return false;
    } else {
      return true;
    }
  }

  getPayULink() {
    let requestObj = {
      'paymentType': this.paymentMode,
      'orderId': this.insuranceOrderId,
      'product': 'TRAVEL_INSURANCE',
      'deviceType': 'WEB',
      'orderType': 'TRAVEL_INSURANCE',
      'bankId': this.bankAccountId
    };
    // if (this.paymentMode == "NB") {
      // requestObj['bankId'] = this.bankAccountId;
    // }
    this.orderService.getPayUOtherLink(requestObj).subscribe(resp => {
      this.showLoader = false;
      var respUPIPayLinkData = JSON.parse(JSON.stringify(resp.body));
      localStorage.setItem(ConstantsKey.IS_INSURANCE_ORDER_DONE, "IN_PROCESS");

      if (respUPIPayLinkData.status == "SUCCESS") {
        // if(this.paymentMode == "NB") {
        //   this.NBPaymentHtml = respUPIPayLinkData.htmlCode;
        //   document.open();          
        //   document.write(this.NBPaymentHtml);
        //   document.close();
        // } else if(this.paymentMode == "UPI") {
        //   window.location.href = respUPIPayLinkData.redirectionURL;
        // }
        if (respUPIPayLinkData.redirectionURL) {
          window.location.href = respUPIPayLinkData.redirectionURL;
        } else {
          this.NBPaymentHtml = respUPIPayLinkData.htmlCode;
          document.open();
          document.write(this.NBPaymentHtml);
          document.close();
        }
      } else if (respUPIPayLinkData.status == "ERROR") {
        let errMsg: string = respUPIPayLinkData.errorDescription;
        if (errMsg.includes("not support PayU")) {
          this.paymentGateway();
        }
      }



    }, err => {
      // console.log("err callQuotation >", err);
      this.toast.error(err.error.message);
    });
  }

  paymentGateway() {
    var responsePayment;
    this.insuranceService.insuranceGetPaymentGatewayLink(this.insuranceOrderId, this.bankAccountId).subscribe(resp => {
      responsePayment = resp.body;
    }, error => {
      this.showLoader = false;
      responsePayment = JSON.parse(this.cryptoUtils.resDecrypt(error.error.text));
      localStorage.setItem(ConstantsKey.IS_INSURANCE_ORDER_DONE, "IN_PROCESS");
      window.location.href = responsePayment.payment_link;
    });
  }


}
